import React from 'react';

import { CloudDownloadOutlined } from '@ant-design/icons';

import IntlMessages from '@src/util/IntlMessages';

import styles from './index.module.less';

export type AttachmentLoadingType = 'file' | 'photo' | 'video';

type AttachmentLoadingStateProps = {
  count: number;
  type: AttachmentLoadingType;
};

const MESSAGE_IDS: Record<AttachmentLoadingType, string> = {
  file: 'eventTypes.component.loadingFiles',
  photo: 'eventTypes.component.loadingPhotos',
  video: 'eventTypes.component.loadingVideos',
};

const PLACEHOLDER_IDS = ['first', 'second', 'third', 'fourth'];

const AttachmentLoadingState = ({ count, type }: AttachmentLoadingStateProps) => {
  const placeholderIds = PLACEHOLDER_IDS.slice(0, Math.min(count, PLACEHOLDER_IDS.length));
  const isFile = type === 'file';

  return (
    <div className={styles.container} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.message}>
        <CloudDownloadOutlined className={styles.icon} aria-hidden="true" />
        <IntlMessages id={MESSAGE_IDS[type]} values={{ count }} />
      </div>
      <div className={isFile ? styles.fileList : styles.mediaGrid} aria-hidden="true">
        {placeholderIds.map(placeholderId => (
          <span
            className={isFile ? styles.filePlaceholder : styles.mediaPlaceholder}
            key={placeholderId}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(AttachmentLoadingState);
